import { render, staticRenderFns } from "./PatternRegister.vue?vue&type=template&id=efa236d2&"
import script from "./PatternRegister.vue?vue&type=script&lang=js&"
export * from "./PatternRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports